import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, PaginationProps, Select, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getListUserAccount, IAccount } from '../../../../../../api/groupPermission/groupPermissionApi';
import { getSLUnitOption, ISelectOption } from '../../../../../../api/selectOptions/selectOptionsApi';
import { NodataTable } from '../../../../../../components/NoDataTable';
import useDebounce from '../../../../../../hook/useDebounce';
import useLoading from '../../../../../../hook/useLoading';
import { selectorInfoUser } from '../../../../../../store/slices/infoUserSlice';
import { dataPagination, fommatSelectOption, fommatSelectOptionUnit, formatPrice } from '../../../../../../until';
import '../../../style.scss';
import { GROUPTYPE, IInforAddGroup } from '../../AddGroup/AddNewGroup';
import { useCustomerGroupContext } from '../../../indexV2';
import { formatNumber } from '../../../../../../services/mixin';
import { columnDefs, PERMISSION } from '../../AddGroup/Component/AG_Decentralization';

export interface ISelectedUserAccount {
    adminId: number;
    permissionType: PERMISSION;
}
interface IDataDefaulFilterList {
    search?: string;
    listUnit?: number[]
}

const dataDefaulFilterList: IDataDefaulFilterList = {
    listUnit: [],
};

interface props {
    inforAddGroup?: IInforAddGroup
    listUserSelectedAccount: ISelectedUserAccount[]
    setListUserSelectedAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
}

const CG_Decentralization: React.FC<props> = ({
    inforAddGroup, listUserSelectedAccount,
    setListUserSelectedAccount
}) => {
    const pushLoading = useLoading()
    const { groupPermission } = useSelector(selectorInfoUser)
    const {
        // sLUnit, sLCategoryCar
        sLNationwide
    } = useCustomerGroupContext();



    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);

    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [tabPermission, setTabPermission] = useState(PERMISSION.VIEW)


    const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

    const [listUserAccount, setListUserAccount] = useState<IAccount[]>([]);


    const gListUserAccount = useDebounce(async (limit: number = 10, pageNumber: number = 1) => {
        pushLoading(true)
        const { listUnit, search } = dataFilterList
        const result = await getListUserAccount(
            limit, pageNumber, listUnit, undefined,
            search, groupPermission ?? undefined, 1,
        );
        if (result.status) {
            setListUserAccount(result.data)
            setPagination({ current: pageNumber, total: result.total, pageSize: limit });

        } else {
            // pushToast(result.message, "error", 2000);
        }
        pushLoading(false)
    }, 1000)

    //------------------------------------
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) return;

        const api = event.api;
        const selectedNodes = api.getSelectedNodes().filter(n => n.data);
        const selectedIdsOnPage = selectedNodes.map(n => String(n.data.id));

        const currentPageIds = (listUserAccount ?? []).map((row: any) => String(row.id));

        // --- Tạo bản sao của selectedIds hiện tại ---
        const nextSet = new Set(selectedIds);

        // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
        const added: string[] = [];
        const removed: string[] = [];

        // Kiểm tra từng ID trên trang hiện tại
        for (const id of currentPageIds) {
            const isCurrentlySelected = selectedIdsOnPage.includes(id);
            const wasPreviouslySelected = selectedIds.has(id);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                // ID mới được chọn
                added.push(id);
                nextSet.add(id);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                // ID bị bỏ chọn
                removed.push(id);
                nextSet.delete(id);
            }
        }

        // console.log('Added:', added, 'Removed:', removed);

        // 👉 Cập nhật danh sách selected account
        handleChangeSelectedUserAccount(added, removed);

        setSelectedIds(nextSet);
    }, [selectedIds, listUserAccount, tabPermission]);
    //------------------------------------

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedUserAccount = (itemsAdd: string[], itemsRemove: string[]) => {
        setListUserSelectedAccount((prevList) => {
            // Nếu có add
            if (itemsAdd.length > 0) {
                const newUsers = itemsAdd.map((id) => ({
                    adminId: Number(id),
                    permissionType: tabPermission,
                }));
                return [...prevList, ...newUsers];
            }

            // Nếu có remove
            if (itemsRemove.length > 0) {
                return prevList.filter((user) => !itemsRemove.includes(user.adminId.toString()));
            }

            return prevList;
        });
    };

    // --- Khi đổi page ---
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListUserAccount(pageSize, pageNumber);
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && listUserAccount && listUserAccount.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIds.has(String(node.data.id))) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [listUserAccount, selectedIds]);

    useEffect(() => {
        setDataFilterList(dataDefaulFilterList)
        if (inforAddGroup?.status === GROUPTYPE.SHARED) {
            //Xóa ds phân quyền đã chọn
            setSelectedIds(new Set())
            setListUserSelectedAccount([])
        }
    }, [inforAddGroup?.status]);

    useEffect(() => {
        gListUserAccount()
    }, [dataFilterList])

    // useEffect(() => {
    //     console.log(inforAddGroup);

    // }, [inforAddGroup])
    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white rounded">
            <div className="custom-page-css flex items-center gap-2">
                <div className='custom-page-css flex-1 d-flex align-center gap-2'>
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                        <div className="d-flex align-center  w-full">
                            {/* <Select
                                showSearch={false}
                                allowClear
                                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="Đơn vị"
                                suffixIcon={null}
                                options={sLUnit}
                                value={dataFilterList?.listUnit}
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            /> */}

                            <TreeSelect
                                className={'custome-select-t w-full border-F2F4F7'}
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterList.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            />

                        </div>
                        {/* <div className="  h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3 " />
                        </div> */}
                    </div>
                </div>
                <div className='custom-page-css flex-1 d-flex align-center gap-2'
                // onClick={() => handleClearSelection()}
                >
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                        <div className="d-flex align-center  w-full">
                            <Select
                                showSearch
                                allowClear
                                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="Phòng ban"
                                suffixIcon={null}
                            // options={cLTypeVehicle}
                            // value={dataFilterList.typeVehicleId}
                            // onChange={(e) => setDataFilterList({ ...dataFilterList, typeVehicleId: e })}
                            />

                        </div>
                        <div className="  h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3 " />
                        </div>
                    </div>
                </div>

                <div className="custom-page-css flex-3  border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm tài khoản người dùng"
                        className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>
            </div>
            <div className="custom-page-css flex items-center justify-between gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
                    <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(selectedIds.size)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div className={`${tabPermission === PERMISSION.VIEW ? 'border-40A9FF bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.VIEW)}
                    >
                        <span className={`${tabPermission === PERMISSION.VIEW ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Xem</span>
                    </div>
                    <div className="custom-page-css divider"></div>
                    <div className={`${tabPermission === PERMISSION.EDIT ? 'border-40A9FF bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.EDIT)}
                    >
                        <span className={`${tabPermission === PERMISSION.EDIT ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Xem, sửa</span>
                    </div>
                </div>
            </div>
            <div className="ag-theme-alpine custom-table-ag">
                <AgGridReact
                    domLayout="autoHeight"
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    rowData={listUserAccount}
                    columnDefs={columnDefs}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    overlayNoRowsTemplate={NodataTable}
                    rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                    getRowId={getRowId}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                        className='rs-pagination'
                        onChange={onPaginationChange}
                    />
                </div>
            </ConfigProvider>
        </div>
    )
}
export default CG_Decentralization
